import PropTypes from 'prop-types'
import { step } from 'assets/js/utils/propTypes'

export const propTypes = {
  steps: PropTypes.arrayOf(step)
}
